import {
  Disclaimer,
  Div,
  lightTheme,
  MenuIssueIcon,
  SupportTicketType,
  ticketTypeLabel,
} from '@vgrubs/components';

/**
 * What kind of request a ticket is, in the list row.
 *
 * Every type but one is about money or an order and reads as plain grey text.
 * A menu issue is neither, so it carries a fork and knife in blue - support
 * scanning the list should not have to read the word to know it goes to
 * whoever edits menus.
 */
export const TicketTypeLabel = ({ type }: { type: SupportTicketType }) => {
  if (type !== 'menuIssue') {
    return <Disclaimer $m="0">{ticketTypeLabel(type)}</Disclaimer>;
  }

  return (
    <Div $flex $alignCenter $gap="4px">
      <MenuIssueIcon color={lightTheme.blue} />
      <Disclaimer $m="0" $color={lightTheme.blue} $semiBold>
        {ticketTypeLabel(type)}
      </Disclaimer>
    </Div>
  );
};
